import React, { FC, ReactNode } from 'react'
import { Box, Stack, Typography } from '@mui/material'

import { PORTAL_TEXT } from '@/apps/latest/shared/styles/portalTypography'

// Notion 流 borderless subsection 見出し. 旧 Section の border-bottom 箱化を解消する後継.
// 区切りは margin gap 側 (= 親 Stack の gap={3} 等) で確保.
// heading: sectionHeading (13/600), description: sectionDesc (12/secondary).
interface SubsectionHeaderProps {
  heading: ReactNode
  description?: ReactNode
  /** heading の右に出す actions (= status chip / button 等). 任意. */
  actions?: ReactNode
}

export const SubsectionHeader: FC<SubsectionHeaderProps> = ({
  heading,
  description,
  actions,
}) => (
  <Box sx={{ mb: 1.5 }}>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={1}
    >
      <Typography sx={PORTAL_TEXT.sectionHeading}>{heading}</Typography>
      {actions && <Box>{actions}</Box>}
    </Stack>
    {description && (
      <Typography sx={{ ...PORTAL_TEXT.sectionDesc, mt: 0.5 }}>
        {description}
      </Typography>
    )}
  </Box>
)
